angular.module('wbDashboard').config([
    '$stateProvider', '$provide', '$urlServiceProvider', '$locationProvider', '$httpProvider', '$controllerProvider', '$animateProvider',
    'Constant', 'CommonConstant', 'localStorageServiceProvider', '$analyticsProvider', 'PlaidServiceProvider',
    'IdleProvider', 'GoogleApiProvider', 'StickyStackDefaults', 'bugsnagClientProvider',
function ($stateProvider, $provide, $urlServiceProvider, $locationProvider, $httpProvider, $controllerProvider, $animateProvider,
          Constant, CommonConstant, localStorageServiceProvider, $analyticsProvider, PlaidServiceProvider,
          IdleProvider, GoogleApiProvider, StickyStackDefaults, bugsnagClientProvider) {

    function getTemplatePath(template, component) {
        if (component) {
            //TODO: make this multiple levels deep?
            var componentName = template.split(".")[0];
            return Constant.componentDir + componentName + "/" + template + ".tpl.html";
        } else {
            //default existing behavior
            return Constant.themeDir + template + ".tpl.html";
        }
    }

    $locationProvider.html5Mode(true).hashPrefix('!');
    //ignore trailing slashes
    $urlServiceProvider.config.strictMode(false);

    //disable animations for items with this class
    $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);
    $animateProvider.customFilter(function(el) {
        //css animations will still work, but delay of hide/show due to animation will not
        //never use the animation provider for these elements:
        return !["input", "button"].includes(el.tagName.toLowerCase());
    });


    bugsnagClientProvider.init({
        releaseStage: CommonConstant.environment,
        apiKey: CommonConstant.bugsnagApiKey
    });

    var uuidRegEx = "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";
    $stateProvider
    /**
     * Public Routes
    **/
        .state("public", {
            abstract: true,
            templateUrl: getTemplatePath("public.public-base", true),
            params: { maintenanceMode: false },
            data: {
                requireLogin: false,
                showMenu: false,
                menuPath: []
            }
        })
            .state("public.maintenance", {
                url: "/maintenance",
                templateUrl: getTemplatePath("public.maintenance", true)
            })
            .state("public.logout", {
                url: "/logout",
                controller: "LogoutController",
                templateUrl: "app/templates/logout.tpl.html",
                params: { message : null }
            })
            .state("public.login", {
                url: "/login",
                controller: "LoginControllerAurea",
                templateUrl: getTemplatePath("public.login", true)
            })
            .state("public.login.otp", {
                url: "/otp",
                controller: "LoginOTPControllerAurea",
                templateUrl: getTemplatePath("public.otp", true)
            })
            .state("public.test", {
                url: "/test",
                controller: "TestControllerAurea",
                templateUrl: getTemplatePath("test")
            })
            .state("public.style-guide", {
                url: "/style-guide/{page}",
                controller: "StyleGuideControllerAurea",
                templateUrl: getTemplatePath("style-guide", true),
                params: { page: { value: null, squash: true, dynamic: true } }
            })
            .state("public.signup-request", {
                url: "/signup-request?alias&email&code",
                controller: "SignupControllerAurea",
                templateUrl: getTemplatePath("public.signup-request", true),
                params: { code: { value: null, squash: true, dynamic: true } }
            })
                .state("public.signup-request.prefill", {
                    //need separate route to allow no '/' on signup-request by itself
                    url: "/{referralCode}?"
                })
            .state("public.username-recover", {
                url: "/username-recover",
                controller: "RecoverControllerAurea",
                templateUrl: getTemplatePath("public.username-recover", true)
            })
            .state("public.password-recover", {
                url: "/password-recover",
                controller: "RecoverControllerAurea",
                templateUrl: getTemplatePath("public.password-recover", true)
            })
            .state("public.password-update", {
                url: "/password-update/{resetToken}",
                controller: "RecoverControllerAurea",
                templateUrl: getTemplatePath("public.password-update", true)
            })
    /**
     * Logged-in routes
    **/
        .state("base", {
            abstract: true,
            controller: "BaseControllerAurea",
            resolve: {
                /**
                 * Resolve all the things.  Make sure the most important endpoints are loaded before anything else
                 * on the dashboard
                 */
                multiResolve: ['User', 'PlanService', 'PlanningService', 'FormulaService', 'FeatureFlagService', 'Guidance', 'Session', 'Notification', 'Login', '$timeout', '$q', '$rootScope', '$window',
                function(User, PlanService, PlanningService, FormulaService, FeatureFlagService, Guidance, Session, Notification, Login, $timeout, $q, $rootScope, $window) {
                    //should always be showing the loading screen initially
                    $rootScope.mainLoadingScreen = true;
                    var loadingTimer = $timeout(function() {
                        //reload the page after 45sec
                        window.location.reload();
                    }, 1000 * 60);
                    var result;
                    return Login.updateToken().then(function(data) {

                        result = data;

                        //want these to be requested after overview and milestones
                        $timeout(function() {
                            //failure on these will be ignored

                            var plans = PlanService.retrievePlans(true);
                            var performance = User.retrieveNewPerformance();

                            PlanService.user.retrievePortfolios(null, true);
                            User.retrieveDetail(true);
                            FeatureFlagService.retrieveFeatures(true);
                            FormulaService.user.retrieveFormulas(true);
                            PlanService.user.retrieveAutos(true);
                            Notification.load();

                            // PlanningService.retrieveRecommendations(true);

                            $q.all([plans, performance]).then(function() {
                                User.retrieveActivity({page_start:0, page_max:100});
                                User.retrieveActivityPending();
                            });

                        });

                        var guidance = Guidance.load().then(function() {
                            if (!Guidance.unreadCount) {
                                Guidance.viewedAll = true;
                            }
                        });

                        return $q.all([User.retrieveOverview(true), User.retrieveAllMilestones(true), guidance]);
                    }).then(function(data) {
                        let [overview, milestones, guidance] = data;

                        if (result.status === "migrate") {
                            $timeout(function() {
                                $rootScope.$state.go('base.security-update', {}, {location: 'replace'});
                            });
                        }
                    }).catch(function(response) {
                        // if (err.status === -1) {
                            //refresh probably cancelled due to page change
                        // } else {
                            //refresh failed, must have a bad token
                        // }

                        if ([504].includes(response.status)) {
                            //was a timeout
                            $timeout(function() {
                                $window.location.refresh();
                            }, 1000);
                        }
                        if (![403,412,503].includes(response.status)) {
                            //if it's any of those codes it would have been handled in the error handler
                            //so skip logging them out
                            Session.set('logout-message', {
                                message: 'There was an error loading your account, please email support@axosinvest.com.',
                                type: 'danger'
                            });
                            $rootScope.$state.go('public.logout', {message: false});
                        }
                    }).finally(function() {
                        $timeout.cancel(loadingTimer);
                        $timeout(function() {
                            $rootScope.mainLoadingScreen = false;
                        }, 1000);
                    });
                }]
            },
            // resolvePolicy: { when: "EAGER", async: "NOWAIT" },
            templateUrl: getTemplatePath('base'),
            data: {
                requireLogin: true,
                showMenu: true,
                menuPath: []
            }
        })
            .state("base.redirected", {
                url: "/redirected",
                controller: ['Auth', '$state', function(Auth, $state) {
                    //temporarily allow this route inside of base with no requireLogin so it will validate the redirect token
                    var target = Auth.getTarget();
                    if (!target || !target.path) {
                        target = {path:"base.overview"};
                    }
                    $state.go(target.path, target.params, {location: 'replace'});
                }],
                templateUrl: getTemplatePath("ui-view"),
                data: {
                    requireLogin: false,
                }
            })
            .state("base.security-update", {
                url: "/security-update/{page}",
                controller: "SecurityUpdateControllerAurea",
                templateUrl: getTemplatePath("security-update", true),
                params: { page: { value: "overview", squash: true, dynamic: true } },
                data: {
                    showMenu: false,
                }
            })
            .state("base.overview", {
                url: "/overview",
                redirectTo: 'base.overview.summary.today'
            })
                .state("base.overview.past", {
                    //old route, just so url doesn't die
                    url: "/past",
                    redirectTo: 'base.overview.summary.progress'
                })
                .state("base.overview.summary", {
                    url: "/summary",
                    abstract: true,
                    controller: "OverviewSummaryControllerAurea",
                    templateUrl: getTemplatePath("overview.summary", true),
                    params: { page: { value: null } },
                })
                    .state("base.overview.summary.today", {
                        url: "/today",
                        redirectTo: 'base.overview.summary.plan',
                        // controller: "OverviewSummaryTodayControllerAurea",
                        // templateUrl: getTemplatePath("overview.summary.today", true),
                        // params: { page: { value: "today" } },
                    })
                    .state("base.overview.summary.plan", {
                        url: "/plan",
                        controller: "OverviewSummaryPlanControllerAurea",
                        templateUrl: getTemplatePath("overview.summary.plan", true),
                        params: { page: { value: "plan" } },
                    })
                    .state("base.overview.summary.progress", {
                        url: "/progress",
                        controller: "OverviewSummaryProgressControllerAurea",
                        templateUrl: getTemplatePath("overview.summary.progress", true),
                        params: { page: { value: "progress" } },
                    })
            .state("base.milestone", {
                url: "/milestone",
                abstract: true,
                controller: "MilestoneControllerAurea",
                data: {
                    menuPath: ["milestones"]
                }
            })
                .state("base.milestone.overview", {
                    url: "/{msId:"+uuidRegEx+"}",
                    controller: "MilestoneOverviewControllerAurea",
                    templateUrl: getTemplatePath('milestone.overview', true),
                    // params: { msId: { value: null, squash: false } }
                })
                    .state("base.milestone.overview.delete", {
                        url: "/delete",
                        controller: "MilestoneDeleteControllerAurea",
                        templateUrl: getTemplatePath('milestone.delete', true)
                    })
            .state("base.milestone-mod", {
                url: "/milestone",
                abstract: true,
                controller: "MilestoneModControllerAurea",
                data: {
                    menuPath: ["milestones"]
                }
            })
                .state("base.milestone-mod.create", {
                    // parent: "base",
                    abstract: true,
                    url: "/create",
                    controller: "MilestoneModCreateController",
                    templateUrl: getTemplatePath("milestone-mod.create", true),
                    params: { msType : null, redirectSection: false },
                    data: { pageTitle: "Milestone Create" }
                })
                    .state("base.milestone-mod.create.steps", {
                        url: "/{page}/{subpage}",
                        controllerProvider: ['$stateParams', function($stateParams) {
                            //provide dynamic controller name based on url param
                            var camelType, controllerName;
                            if ($stateParams.type) {
                                camelType = $stateParams.type.toLowerCase().replace(/(\b|_)[a-z]/g, function (letter) {
                                    return letter.replace("_", "").toUpperCase();
                                });

                                controllerName = "MilestoneMod" + camelType + "Controller";
                                if ($controllerProvider.has(controllerName)) {
                                    return controllerName;
                                }
                            }

                            return function() {};
                        }],
                        templateUrl: "/common/src/app/shared/milestone-pages.tpl.html",
                        params: {
                            type: { value: null, dynamic: false },
                            page: { value: "select", squash: true, dynamic: true },
                            subpage: { value: null, squash: true, dynamic: true }
                        }
                    })
                .state("base.milestone-mod.update", {
                    // parent: "base",
                    abstract: true,
                    url: "/{msId}/update",
                    controller: "MilestoneModUpdateController",
                    resolve: {
                        milestoneResolve: ['User', '$state', '$q', '$timeout', '$transition$', function(User, $state, $q, $timeout, $transition$) {
                            return $q.when(1).then(function() {
                                var params = $transition$.params('to');
                                return User.getMilestones(params.msId);
                            });
                        }]
                    },
                    onEnter: ['milestoneResolve', '$transition$', function(milestoneResolve, $transition$) {
                        var params = $transition$.params('to');
                        var ms = milestoneResolve;

                        if (!ms) {
                            return $transition$.router.stateService.target('base.overview');
                        }
                        if (!params.type) {
                            params = angular.copy(params);
                            params.type = (!ms.type_account) ? ms.type : 'other';

                            return $transition$.router.stateService.target($transition$.to().name, params, {notify: false});
                        }
                    }],
                    templateUrl: getTemplatePath("milestone-mod.update", true),
                    data: { pageTitle: "Milestone Update" }
                })
                    .state("base.milestone-mod.update.steps", {
                        url: "/{page}",
                        controllerProvider: ['milestoneResolve', '$transition$', function(milestoneResolve, $transition$) {
                            //provide dynamic controller name based on milestone type
                            var camelType, controllerName,
                                toParams = $transition$.params('to');
                            if (toParams.type) {
                                camelType = toParams.type.toLowerCase().replace(/(\b|_)[a-z]/g, function (letter) {
                                    return letter.replace("_", "").toUpperCase();
                                });
                                if (milestoneResolve && milestoneResolve.type_account) {
                                    camelType = "Other";
                                }

                                controllerName = "MilestoneMod" + camelType + "Controller";
                                if ($controllerProvider.has(controllerName)) {
                                    return controllerName;
                                }
                            }

                            return function() {};
                        }],
                        templateUrl: "/common/src/app/shared/milestone-pages.tpl.html",
                        params: {
                            type: { value: null, dynamic: false },
                            page: { value: null, dynamic: true }
                        }
                    })
            .state("base.funding", {
                abstract: true,
                url: "/funding",
                controller: "FundingControllerAurea",
                resolve: {
                    activityResolve: ['User', function (User) {
                    }]
                },
				templateUrl: getTemplatePath("funding", true),
                data: {
                    menuPath: ["funding"]
                }
            })
                .state("base.funding.options", {
                    url: "",
                    controller: "FundingOptionsControllerAurea",
                    templateUrl: getTemplatePath("funding.options", true)
                })
                .state("base.funding.rollovers", {
                    url: "/rollovers",
                    controller: "FundingRolloversControllerAurea",
					templateUrl: Constant.componentDir + "funding/rollovers/funding.rollovers.tpl.html",
                })
                    .state("base.funding.rollovers.create", {
                        url: "/create/{page}",
                        controller: "FundingRolloversCreateControllerAurea",
                        templateUrl: Constant.componentDir + "funding/rollovers/funding.rollovers.create.tpl.html",
						params: {
							page: { value: 'account-source', dynamic: true },
						}
                    })
                    .state("base.funding.rollovers.pending", {
                        url: "/pending",
                        controller: "FundingRolloversPendingControllerAurea",
                        templateUrl: Constant.componentDir + "funding/rollovers/funding.rollovers.pending.tpl.html",
                    })
                        .state("base.funding.rollovers.pending.status", {
                            url: "/{rollover_id}/{page}",
                            resolve: {
                                rolloversResolve: ['PlanService', function (PlanService) {
                                    //just need to make sure this is cached before the page loads
                                    return PlanService.user.retrieveRollovers();
                                }]
                            },
                            templateUrl: Constant.componentDir + "funding/rollovers/funding.rollovers.pending.status.tpl.html",
                            params: {
                                rollover_id: { value: null },
                                page: { value: '', dynamic: true },
                            }
                        })
                .state("base.funding.auto-deposit", {
                    url: "/auto-deposit",
                    controller: "AutoDepositControllerAurea",
					templateUrl: Constant.componentDir + "funding/auto-deposit/funding.auto-deposit.tpl.html",
                })
                    .state("base.funding.auto-deposit.milestone", {
                        url: "/{msId:"+uuidRegEx+"}/{page}",
                        controller: "AutoDepositMilestoneControllerAurea",
						templateUrl: Constant.componentDir + "funding/auto-deposit/funding.auto-deposit.milestone.tpl.html",
                        params: {
                            page: { value: 'auto-deposit', squash: true, dynamic: true },
                            msId: null
                        }
                    })
                .state("base.funding.transfer", {
                    url: "/transfer-funds/{page}",
                    controller: "FundingTransferControllerAurea",
                    resolve: {
                        bankAccountsResolve: ['User', function (User) {
                            //just need to make sure this is cached before the page loads
                            return User.retrieveBankAccounts();
                        }]
                    },
                    templateUrl: getTemplatePath("funding.transfer", true),
                    params: {
                        page: { value: null, squash: true, dynamic: true },
                        pageStart: null,
                        msId: null,
                        accountNumber: null,
                        transactionId: null,
                        type: null,
                        amount: null
                    }
                })
                .state("base.funding.activityhistorical", {
                    url: "/activity_historical",
                    controller: "FundingActivityHistoricalControllerAurea",
                    templateUrl: getTemplatePath("funding.activity.historical", true)
                })
                .state("base.funding.activity", {
                    url: "/activity",
                    controller: "FundingActivityControllerAurea",
                    templateUrl: getTemplatePath("funding.activity", true)
                })
                    .state("base.funding.activity.detail", {
                        url: "/{uuid}",
                        controller: "FundingActivityDetailControllerAurea",
                        templateUrl: getTemplatePath("funding.activity.detail", true),
                        params: {
                            uuid: { value: null },
                            transaction: null
                        }
                    })
            .state("base.profile", {
                url: "/profile",
                abstract: true,
                controller: "ProfileControllerAurea",
                templateUrl: getTemplatePath("profile", true),
                data: {
                    menuPath: ["profile"]
                }
            })
                .state("base.profile.settings", {
                    url: "",
                    views: {
                        // need this empty view or this state will replace the ui-view in the parent state
                        // which is the entire page
                    }
                })
                .state("base.profile.close", {
                    abstract: true,
                    url: "/close",
                    controller: "ProfileCloseAccountControllerAurea",
                    templateUrl: getTemplatePath("profile.close-account", true)
                })
                    .state("base.profile.close.steps", {
                        url: "/{page}",
                        params: { page: { value: "start", squash: true } }
                    })
                .state("base.profile.contact", {
                    url: "/contact",
                    controller: "ProfileContactControllerAurea",
                    templateUrl: getTemplatePath("profile.contact", true)
                })
                    .state("base.profile.contact.email", {
                        url: "/email",
                        templateUrl: getTemplatePath("profile.contact.email", true)
                    })
                    .state("base.profile.contact.phone", {
                        url: "/phone",
                        templateUrl: getTemplatePath("profile.contact.phone", true)
                    })
                    .state("base.profile.contact.mail", {
                        url: "/mail",
                        templateUrl: getTemplatePath("profile.contact.mail", true)
                    })
                .state("base.profile.banks", {
                    url: "/banks",
                    controller: "ProfileBanksControllerAurea",
                    templateUrl: getTemplatePath("profile.banks", true),
                })
                .state("base.profile.financial", {
                    //old route, just so url doesn't die
                    url: "/financial",
                    redirectTo: "base.profile.banks"
                })
                .state("base.profile.employer", {
                    url: "/employer",
                    controller: "ProfileEmployerControllerAurea",
                    templateUrl: getTemplatePath("profile.employer", true),
                    params: { updateBank: null }
                })
                .state("base.profile.planning", {
                    url: "/planning",
                    controller: "ProfilePlanningControllerAurea",
                    resolve: {
                        completedResolve: ['PlanningService', '$transition$', function (PlanningService, $transition$) {
                            return PlanningService.retrieveSurveysCompleted().then(function (surveys) {
                                return surveys;
                            });
                        }]
                    },
                    templateUrl: getTemplatePath("profile.planning", true),
                    params: { updateBank: null }
                })
                .state("base.profile.security", {
                    url: "/security",
                    controller: "ProfileSecurityControllerAurea",
                    templateUrl: getTemplatePath("profile.security", true)
                })
                    .state("base.profile.security.password", {
                        url: "/password",
                        templateUrl: getTemplatePath("profile.security.password", true)
                    })
                .state("base.profile.documents", {
                    url: "/documents/{type}",
                    controller: "ProfileDocumentsControllerAurea",
                    templateUrl: getTemplatePath("profile.documents", true),
                    params: { type: null, squash: true }
                })
            .state("base.formulas", {
                url: "/formulas",
                controller: "FormulasControllerAurea",
                templateUrl: getTemplatePath("formulas", true)
            })
                .state("base.formulas.wallet-edit", {
                    url: "/wallet/{page}",
                    controller: "FormulasWalletControllerAurea",
                    templateUrl: getTemplatePath("formulas.wallet.edit", true),
                    params: {
                        page: {value: 'wallet-autos', dynamic: true },
                    }
                })
                .state("base.formulas.detail", {
                    url: "/detail/{formulaSlug}",
                    controller: "FormulaDetailControllerAurea",
                    templateUrl: getTemplatePath("formulas.detail", true)
                })
                .state("base.formulas.edit", {
                    url: "/edit/{formulaSlug}",
                    controller: "FormulasEditControllerAurea",
                    resolve: {
                        //this is needed as a placeholder as it only matters if it's injected into create
                        userFormulasResolve: function() { return [1]; }
                    },
                    templateUrl: getTemplatePath("formulas.edit", true),
                    data: { pageTitle: "Formulas Edit" }
                })
                    .state("base.formulas.edit.steps", {
                        url: "/{page}",
                        templateUrl: getTemplatePath("formulas.edit.pages", true),
                        params: {
                            page: {value: 'start', dynamic: true },
                        }
                    })
                .state("base.formulas.create", {
                    url: "/create",
                    controller: "FormulasEditControllerAurea",
                    resolve: {
                        formulasResolve: ['$stateParams', 'FormulaService', function ($stateParams, FormulaService) {
                            return FormulaService.retrieveFormulas();
                        }],
                        userFormulasResolve: ['$stateParams', 'FormulaService', function ($stateParams, FormulaService) {
                            return FormulaService.user.retrieveFormulas();
                        }]
                    },
                    templateUrl: getTemplatePath("formulas.create", true),
                    params: {
                        formulaSlug: { value: null, dynamic: true }
                    },
                    data: { pageTitle: "Formulas Create" }
                })
                    .state("base.formulas.create.steps", {
                        url: "/{formulaSlug}/{page}",
                        OFFcontrollerProvider: ['$stateParams', '$controller', function($stateParams, $controller) {
                            //provide dynamic controller name based on url param
                            var camelSlug = $stateParams.formulaSlug.toLowerCase().replace(/\b[a-z]/g, letter => {letter.replace("-","").toUpperCase(); });
                            var controllerName = "FormulasCreate" + camelSlug + "ControllerAurea";
                            if ($controllerProvider.has(controllerName)) {
                                return controllerName;
                            }
                            return function() {};
                        }],
                        templateUrl: getTemplatePath("formulas.edit.pages", true),
                        params: {
                            page: {value: 'start', dynamic: true },
                        }
                    })
            .state("base.plans", {
                url: "/plans",
                controller: "PlansControllerAurea",
                templateUrl: getTemplatePath("plans", true)
            })
                .state("base.plans.info", {
                    url: "/{pslug}/info",
                    controller: "PlansInfoControllerAurea",
                    resolve: {
                        pageTitle: ['$state$', '$stateParams', 'PlanService', function($state$, $stateParams, PlanService) {
                            if (PlanService.info[$stateParams.pslug]) {
                                $state$.data.pageTitle = PlanService.info[$stateParams.pslug].name + ' Detail';
                            } else {
                                $state$.data.pageTitle = "Package Detail";
                            }
                        }],
                    },
                    templateUrl: getTemplatePath("plans.info", true)
                })
                    .state("base.plans.info.enable", {
                        url: "/enable",
                        views: {
                            // need this empty view or this state will replace the ui-view in the parent state
                            // which is the entire page
                        },
                        params: { fslug: null }
                    })
                    .state("base.plans.info.feature", {
                        url: "/{fslug}",
                        controller: "PlansInfoFeatureControllerAurea",
                        resolve: {
                            pageTitle: ['$state$', '$stateParams', '$filter', function($state$, $stateParams, $filter) {
                                $state$.data.pageTitle = $filter('ucwords')($stateParams.fslug) + ' Detail';
                            }],
                        },
                        templateUrl: getTemplatePath("plans.info.feature", true)
                    })
                .state("base.plans.detail", {
                    //base controller for plans
                    abstract: true,
                    url: "/{pslug}/detail",
                    controller: "PlansDetailControllerAurea",
                    params: { init: false, returnTo: null }
                })
                    .state("base.plans.detail.plan", {
                        //specific controller for plans
                        controllerProvider: ['$state$', '$stateParams', 'PlanService', function($state$, $stateParams, PlanService) {
                            //provide dynamic controller name based on url param
                            var camelSlug = $stateParams.pslug.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                                return letter.replace("-","").toUpperCase();
                            });
                            var controllerName = "PlansDetail" + camelSlug + "ControllerAurea";
                            if ($controllerProvider.has(controllerName)) {
                                if (PlanService.info[$stateParams.pslug]) {
                                    $state$.data.pageTitle = PlanService.info[$stateParams.pslug].name + ' Detail';
                                }
                                return controllerName;
                            }
                            $state$.data.pageTitle = "Package Detail";
                            return function() {};
                        }],
                        url: "",
                        templateUrl: getTemplatePath("plans.detail", true),
                        data: { pageTitle: "Package Detail" }
                    })
                        .state("base.plans.detail.plan.init", {
                            url: "/init",
                            templateUrl: getTemplatePath("plans.detail.init", true),
                            params: { fslug: null }
                        })
                        .state("base.plans.detail.plan.disable", {
                            url: "/disable",
                            templateUrl: getTemplatePath("plans.detail.disable", true)
                        })
                        .state("base.plans.detail.plan.feature", {
                            //base feature controller
                            abstract: true,
                            url: "/{fslug:(?!init)[a-z\-]+}",
                            controller: "PlansDetailFeatureControllerAurea",
                        })
                            .state("base.plans.detail.plan.feature.detail", {
                                //specific feature controller
                                url: "",
                                controllerProvider: ['$state$', '$stateParams', function($state$, $stateParams) {
                                    //provide dynamic controller name based on url param
                                    var camelSlug = $stateParams.fslug.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                                        return letter.replace("-","").toUpperCase();
                                    });
                                    var controllerName = "PlansDetailFeature" + camelSlug + "ControllerAurea";
                                    if ($controllerProvider.has(controllerName)) {
                                        $state$.data.pageTitle = camelSlug + ' Detail';
                                        return controllerName;
                                    }
                                    $state$.data.pageTitle = 'Feature Detail';
                                    return function() {};
                                }],
                                templateUrl: getTemplatePath("plans.detail.feature", true)
                            })
                                .state("base.plans.detail.plan.feature.detail.createIRA", {
                                    url: "/create/{page}",
                                    controller: "PlansDetailFeatureCreateIraAccountControllerAurea",
                                    templateUrl: Constant.componentDir + "plans/plans/taxplan/features/taxpreferredaccount/plans.detail.feature.createIraAccount.tpl.html",
                                    params: {
                                        page: { value: "start", squash: true, dynamic: true },
                                        plaidOnly: null
                                    }
                                })
                                .state("base.plans.detail.plan.feature.detail.edit", {
                                    url: "/edit/{page}",
                                    templateUrl: getTemplatePath("plans.detail.feature.edit", true),
                                    controllerProvider: ['$stateParams', '$controller', function($stateParams, $controller) {
                                        //provide dynamic controller name based on url param
                                        var camelSlug = $stateParams.fslug.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                                            return letter.replace("-","").toUpperCase();
                                        });
                                        var controllerName = "PlansDetailFeatureEdit" + camelSlug + "ControllerAurea";
                                        if ($controllerProvider.has(controllerName)) {
                                            return controllerName;
                                        }
                                        return function() {};
                                    }],
                                    params: {
                                        page: { value: null, squash: true, dynamic: true },
                                        plaidOnly: null
                                    }
                                })
                .state("base.plans.custom", {
                    abstract: true,
                    url: "/custom",
                    controller: "PlansDetailControllerAurea",
                    params: { init: false, returnTo: null }
                })
                    .state("base.plans.custom.portfolioplus", {
                        url: "/portfolioplus",
                        controller: "PlansDetailPortfolioplusControllerAurea",
                        resolve: {
                            allTheThingsResolve: ['User', 'Milestone', 'RiskScore', '$q', function(User, Milestone, RiskScore, $q) {
                                var p, promises = [];
                                var milestones = User.getMilestones();
                                angular.forEach(milestones, function(ms) {
                                    if (   (!ms.allocation.recommendation || !Object.keys(ms.allocation.recommendation).length || !ms.allocation.recommendation.allocation_start)
                                        && !['wallet','cash'].includes(ms.type) ) {
                                        p = Milestone.retrieveGlideRecommend({
                                            milestone_type: ms.type_real,
                                            life_expectancy: ms.metadata.life_expectancy,
                                        }).then(function(glideRecommend) {
                                            ms.allocation.recommendation = glideRecommend;
                                        });
                                        promises.push(p);
                                    }
                                });
                                p = RiskScore.retrievePortfolios();
                                promises.push(p);

                                return $q.all(promises).catch(function() {
                                    //if anything fails still want to continue on to load page
                                });
                            }]
                        },
                        templateUrl: Constant.componentDir + "plans/plans/portfolioplus/customportfolio/index.tpl.html",
                        params: { pslug: "portfolioplus", fslug: "customportfolio" }
                    })
                        .state("base.plans.custom.portfolioplus.disable", {
                            url: "/disable/{page}/{msId}",
                            controller: "PlansDetailDisablePortfolioplusControllerAurea",
                            resolve: {
                                milestoneCountResolve: ['User', function(User) {
                                    var ms = User.getMilestones();
                                    var count = 0;
                                    angular.forEach(ms, function(ms) {
                                        if (ms.allocation.allocation_slug) {
                                            count++;
                                        }
                                    });

                                    return count;
                                }]
                            },
                            templateUrl: Constant.componentDir + "plans/plans/portfolioplus/plans.detail.disable.tpl.html",
                            params: {
                                page: {value: "confirm", dynamic: true},
                                msId: {value: null, dynamic: true}
                            }
                        })
                        .state("base.plans.custom.portfolioplus.core", {
                            controller: "PortfolioplusCoreControllerAurea",
                            url: "/core/{page}",
                            templateUrl: Constant.componentDir + "plans/plans/portfolioplus/customportfolio/core.tpl.html",
                            params: {
                                page: {value: "milestones", squash: true, dynamic: true},
                                msId: {value: null, dynamic: true},
                            }
                        })
                        .state("base.plans.custom.portfolioplus.detail", {
                            controller: "PortfolioplusDetailControllerAurea",
                            url: "/detail/{slug}",
                            resolve: {}, //force inlineLoading
                            templateUrl: Constant.componentDir + "plans/plans/portfolioplus/customportfolio/detail.tpl.html",
                        })
                            .state("base.plans.custom.portfolioplus.detail.edit", {
                                url: "/edit/{page}",
                                controller: "PortfolioplusEditControllerAurea",
                                templateUrl: Constant.componentDir + "plans/plans/portfolioplus/customportfolio/update.tpl.html",
                                params: {
                                    page: {value: null, dynamic: true},
                                }
                            })
                            .state("base.plans.custom.portfolioplus.detail.delete", {
                                url: "/delete/{page}/{msId}",
                                controller: "PortfolioplusDeleteControllerAurea",
                                resolve: {
                                    positionsResolve: ['$stateParams', 'PlanService', function ($stateParams, PlanService) {
                                        return PlanService.user.retrievePortfolioPositions($stateParams.slug);
                                    }]
                                },
                                templateUrl: Constant.componentDir + "plans/plans/portfolioplus/customportfolio/delete.tpl.html",
                                params: {
                                    page: {value: 'confirm', dynamic: true},
                                    msId: {value: null, dynamic: true}
                                }
                            })
                        .state("base.plans.custom.portfolioplus.create", {
                            controller: "PortfolioplusEditControllerAurea",
                            url: "/create/{page}",
                            templateUrl: Constant.componentDir + "plans/plans/portfolioplus/customportfolio/create.tpl.html",
                            params: {
                                page: {value: "start", squash: true, dynamic: true},
                            }
                        })
                        .state("base.plans.custom.portfolioplus.create.featured", {
                            url: "/{featureSlug}",
                            views: {},
                            params: {
                                featureSlug: {value: null, dynamic: true}
                            }
                        })

            .state("base.planning", {
                url: "/planning",
                controller: "PlanningControllerAurea",
                resolve: {
                    recommendationsResolve: ['PlanningService', '$transition$', function (PlanningService, $transition$) {
                        //always refresh recommendations since we don't know what's changed by doing other things
                        //doesn't need to be used directly in controller, just watcher used on getRecommendations
                        var promise = PlanningService.retrieveRecommendations(true);
                        if ($transition$.to().name === "base.planning") {
                            return promise;
                        } else {
                            //need it updated, but can be asynchronous
                            return true;
                        }

                    }]
                },
                params: {
                    riskReturnTo: { value: null },
                },
                templateUrl: getTemplatePath("planning", true),
                redirectTo: 'base.overview.summary.today'
            })
                .state("base.planning.recommendation", {
                    url: "/recommendation/{slugOrId}",
                    controller: "PlanningRecommendationControllerAurea",
                    resolve: {
                        actionResolve: ['$q', '$state', '$state$', '$transition$', 'Message', 'PlanningService', function ($q, $state, $state$, $transition$, Message, PlanningService) {
                            var to = $transition$.params('to');
                            var slugOrId = to.slugOrId.replace(/^survey-/, "");
                            return $q.when(1).then(function() {
                                if (isNaN(slugOrId)) {
                                    //string, must be a recommendation slug
                                    return PlanningService.retrieveRecommendations(slugOrId);
                                } else {
                                    //numeric, must be a survey
                                    return PlanningService.retrieveSurvey(slugOrId);
                                }
                            }).then(function(response) {
                                if (response.landing_description) {
                                    $state$.data.pageTitle = "Planning Recommendation - " + response.landing_description.title;
                                }
                                if (response.recommendation_slug) {
                                    //recommendation
                                } else {
                                    //survey
                                    response.action = "survey";
                                    response.action_type = response.id;
                                }
                                return response;
                            }).catch(function() {
                                Message.set({
                                    text: "Invalid recommendation or survey",
                                    type: "warning",
                                    key: "invalidaction"
                                });
                                if (!$state.transition) {
                                    if ($transition$.from().name === "base.overview") {
                                        $state.go('base.overview', {}, {location: 'replace'});
                                    } else {
                                        $state.go('base.planning', {}, {location: 'replace'});
                                    }
                                }
                                return $q.reject("Invalid recommendation or survey");
                            });
                        }]
                    },
                    templateUrl: getTemplatePath("planning.recommendation", true),
                })
                .state("base.planning.risk-score", {
                    url: "/risk-score/{page}",
                    controller: "PlanningRiskScoreControllerAurea",
                    templateUrl: getTemplatePath("planning.risk-score", true),
                    params: {
                        page: { value: 'risk-score', squash: true, dynamic: true },
                        recommendationSlug: { value: null }
                    }
                })
                .state("base.planning.studentrefi", {
                    url: "/studentrefi/{page}",
                    controller: "PlanningStudentRefiControllerAurea",
                    templateUrl: getTemplatePath("planning.partner.studentrefi", true),
                    params: {
                        page: { value: "introduction", squash: true, dynamic: true },
                        recommendationSlug: { value: null }
                    }
                })
                .state("base.planning.mortgage", {
                    url: "/mortgage/{page}",
                    controller: "PlanningMortgageControllerAurea",
                    templateUrl: getTemplatePath("planning.partner.mortgage", true),
                    params: {
                        page: { value: null, squash: true, dynamic: true },
                        recommendationSlug: { value: null }
                    }
                })
                .state("base.planning.mortgage-new", {
                    url: "/mortgage-new/{page}",
                    controller: "PlanningMortgageNewControllerAurea",
                    templateUrl: getTemplatePath("planning.partner.mortgage-new", true),
                    params: {
                        page: { value: "adjust", squash: true, dynamic: true },
                        recommendationSlug: { value: null }
                    }
                })
                .state("base.planning.haven", {
                    url: "/haven/{page}",
                    controller: "PlanningHavenControllerAurea",
                    templateUrl: getTemplatePath("planning.partner.haven", true),
                    params: {
                        page: { value: "introducing", squash: true, dynamic: true },
                        recommendationSlug: { value: null }
                    }
                })
                .state("public.haven", {
                    url: "/haven/mobile?source&token&monthlyRate&coverageAmount&termLength&recommendationSlug",
                    controller: "PlanningHavenControllerAurea",
                    templateUrl: getTemplatePath("planning.partner.haven.mobile", true),
                    data: {
                        requireLogin: false,
                        showMenu: false,
                    },
                    params: {
                        page: "mobile"
                    }
                })
                .state("base.planning.survey", {
                    url: "/survey/{sId}",
                    controller: "PlanningSurveyControllerAurea",
                    resolve: {
                        surveyResolve: ['PlanningService', '$transition$', function (PlanningService, $transition$) {
                            var sId = $transition$.params('to').sId;
                            return PlanningService.retrieveSurvey(sId).then(function (survey) {
                                return survey;
                            });
                        }],
                        answersResolve: ['PlanningService', 'surveyResolve', '$transition$', function (PlanningService, surveyResolve, $transition$) {
                            if (surveyResolve.completed) {
                                var sId = $transition$.params('to').sId;
                                return PlanningService.retrieveSurveysCompleted(sId);
                            } else {
                                return null;
                            }
                        }]
                    },
                    templateUrl: getTemplatePath("planning.survey", true),
                    params: {
                        recommendationSlug: { value: null }
                    }
                })
                    .state("base.planning.survey.complete", {
                        url: "/complete",
                        templateUrl: getTemplatePath("planning.survey.complete", true),
                        data: { pageTitle: "Survey Complete" }
                    })
                    .state("base.planning.survey.question", {
                        url: "/{code}",
                        resolve: {},
                        templateUrl: getTemplatePath("planning.survey.question", true),
                        params: {
                            code: { value: null, squash: true }
                        },
                        data: { pageTitle: "Survey Question" }
                    })
            .state("base.planning.completed", {
                url: "/completed",
                redirectTo: "base.profile.planning"
            })
            .state("base.invite", {
                url: "/invite",
                controller: "InviteControllerAurea",
                resolve: {
                    invitesResolve: ['User', function(User) {
                        //just to cache the results
                        return User.retrieveInvites();
                    }]
                },
                templateUrl: getTemplatePath("invite", true)
            })
            .state("base.assets", {
                url: "/assets/{classCode}",
                controller: "AssetsControllerAurea",
                resolve: {
                    assetResolve: ['DataService', '$transition$', function(DataService, $transition$) {
                        return DataService.retrieveAssetClasses().then(function() {
                            var classCode = $transition$.params('to').classCode;
                            return DataService.getAssetClass(classCode);
                        });
                    }]
                },
                templateUrl: getTemplatePath("assets", true)
            })
            .state("base.receipt", {
                url: "/receipt",
                controller: "ReceiptControllerAurea",
                templateUrl: getTemplatePath("receipt"),
                params: { receipt : {} }
            })
    ;
    $urlServiceProvider.rules.when('/', Constant.themeHome);
    $urlServiceProvider.rules.otherwise("/");

    /**
     * If a response is 403/412 for not logged in:
     * Give logout message, close all popup modals, logout
     */
    $httpProvider.interceptors.push(['$timeout', '$q', '$location', '$injector', 'Session', function ($timeout, $q, $location, $injector, Session) {
        var $state, $uibModalStack, Display;

        return {
            request: function (config) {
                config.headers = config.headers || {};
                return config;
            },
            responseError: function (rejection) {
                $state = $injector.get('$state');
                $uibModalStack = $injector.get('$uibModalStack');
                try {
                    Display = $injector.get('Display');
                } catch (err) {}

                var isLoginPage = false;
                var currentName = "";
                try {
                    if ($state.transition && $state.transition.$to().name === 'public.login') {
                        isLoginPage = true; //going to login
                    } else if (!$state.transition && $state.current.name === 'public.login') {
                        isLoginPage = true; //is at login
                    }
                    currentName = $state.current.name;
                } catch (err) {}

                if ([403, 412].includes(rejection.status) && !isLoginPage) {
                    if (CommonConstant.devDomains.includes($location.host())) {
                        console.log(rejection);
                    }
                    if ($uibModalStack) { $uibModalStack.dismissAll("Logged out"); }
                    if (currentName !== 'public.login') {
                        Session.set('logout-message', {
                            message: "For your security, we logged you out due to inactivity.",
                            type: "danger"
                        });
                    }
                    $state.go('public.logout');
                }
                if ([503].includes(rejection.status)) {
                    if ($uibModalStack) { $uibModalStack.dismissAll("Site Maintenance"); }
                    if ($state && $state.current && $state.current.name && $state.current.name.includes("public")) {
                        $state.go('.', {maintenanceMode: true});
                    } else if (Display && Display.setViewToMaintenanceMode) {
                        Display.setViewToMaintenanceMode();
                    } else {
                        $state.go('public.maintenance');
                    }

                }
                if (rejection.status >= 500 && ![503, 504].includes(rejection.status)) {
                    //all 500 except 503 & 504, don't care about maintenance or timeouts
                    try {
                        rejection.config.headers["Auth-Token"] = "[redacted]";
                        bugsnagClientProvider.handleBugsnagException({
                            name: "RequestError",
                            message: `${rejection.status} ${rejection.config.method} ${rejection.config.url}`
                        }, rejection, $state);
                    } catch (err) {
                        bugsnagClientProvider.handleBugsnagException(err, null, $state);
                    }
                }
                // return rejection;
                return $q.reject(rejection);
            }
        };
    }]);

    /*- Configure Angulartics to use state base -*/
    $analyticsProvider.withBase(true);
    $analyticsProvider.virtualPageviews(false);

    PlaidServiceProvider.init(CommonConstant.plaid);

    if (CommonConstant.devDomains.includes(window.location.hostname)) {
        Constant.logoutModalTimeout = Constant.logoutModalTimeoutDev;
    }
    IdleProvider.idle(Constant.logoutModalTimeout);
    IdleProvider.timeout(false);
    IdleProvider.keepalive(false);

    GoogleApiProvider.init({
        client_id: CommonConstant.google.apiClientId,
        scripts: ["client"],
        scopes: ["https://www.googleapis.com/auth/contacts.readonly"]
    });

    //global sticky stack setting
    StickyStackDefaults.zIndex = 20;

    //update currenty locale defaults so negative is -$x instead of ($x)
    $provide.decorator('$locale', ['$delegate', function($delegate) {
        if ($delegate.id === 'en-us') {
            $delegate.NUMBER_FORMATS.PATTERNS[1].negPre = '-\u00A4';
            $delegate.NUMBER_FORMATS.PATTERNS[1].negSuf = '';
        }
        return $delegate;
    }]);


    /** Log bugs with bugsnag **/
    $provide.decorator("$exceptionHandler", ['$delegate', '$injector', function($delegate, $injector) {
        return function(exception, cause) {

            let $state = $injector.get('$state');

            if ($state && $state.current && $state.current.name === "public.logout" ) {
                //don't log errors on logout page, they're likely leftover from failed items
                //from before being redirected here
            } else {
                bugsnagClientProvider.handleBugsnagException(exception, cause, $state);
            }

            $delegate(exception, cause);

        };
    }]);

}]);
